module.exports = __webpack_public_path__ + "static/media/hour.d4777cc3.svg";